import InputLabelView from './InputLabelView';

export default InputLabelView;
